var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0418 8.7085C15.0418 11.7691 12.5607 14.2502 9.50016 14.2502M9.50016 14.2502C6.43958 14.2502 3.9585 11.7691 3.9585 8.7085M9.50016 14.2502V17.4168M9.50016 17.4168H6.3335M9.50016 17.4168H12.6668M9.50016 11.0835C8.18849 11.0835 7.12516 10.0202 7.12516 8.7085V3.9585C7.12516 2.64682 8.18849 1.5835 9.50016 1.5835C10.8118 1.5835 11.8752 2.64682 11.8752 3.9585V8.7085C11.8752 10.0202 10.8118 11.0835 9.50016 11.0835Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/Microphone.a8ce516e81731647853882e824cf062c.svg";
export { ForwardRef as ReactComponent };